import React, {Component, Fragment} from "react";
import Label from "ps-react/Label";

class ExampleOptional extends Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	render() {
		return (
			<Fragment>
				<Label htmlFor="name" label="Test"/>
				<input type="text" id="name"/>
			</Fragment>
		);
	}
}

export default ExampleOptional;
